(() => {
  const selector = '[data-castle-scroll-rail]';
  const storySelector = '[data-castle-scroll-story]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRails(scope = document) {
    const roots = [];
    if (scope.matches?.(selector)) roots.push(scope);
    roots.push(...(scope.querySelectorAll?.(selector) || []));

    for (const root of roots) {
      if (root.dataset.castleRailReady) continue;
      const scroller = root.matches('slideshow-component') ? root.querySelector('slideshow-slides') : root;
      if (!scroller) continue;
      root.dataset.castleRailReady = 'true';
      const label = root.getAttribute('aria-label') || 'Scrollable items';
      if (!scroller.hasAttribute('tabindex') || scroller.getAttribute('tabindex') === '-1') scroller.tabIndex = 0;
      if (!scroller.hasAttribute('aria-label')) scroller.setAttribute('aria-label', label);
      if (!scroller.hasAttribute('role') && root.matches('slideshow-component')) scroller.setAttribute('role', 'region');

      if (!scroller.closest(storySelector)) {
        scroller.addEventListener('wheel', event => {
          if (reducedMotion.matches || window.matchMedia('(pointer: coarse)').matches ||
              event.ctrlKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY) ||
              scroller.scrollWidth <= scroller.clientWidth + 2) return;
          const max = scroller.scrollWidth - scroller.clientWidth;
          const next = scroller.scrollLeft + event.deltaY;
          if ((next > 0 && next < max) || (next <= 0 && scroller.scrollLeft > 0) ||
              (next >= max && scroller.scrollLeft < max)) {
            event.preventDefault();
            scroller.scrollLeft = Math.max(0, Math.min(max, next));
          }
        }, { passive: false });
      }

      scroller.addEventListener('keydown', event => {
        if (event.target !== scroller) return;
        const step = Math.max(160, Math.round(scroller.clientWidth * 0.75));
        const move = left => {
          if (reducedMotion.matches) scroller.scrollLeft = left;
          else scroller.scrollBy({ left, behavior: 'smooth' });
        };
        if (event.key === 'ArrowRight') { event.preventDefault(); move(scroller.scrollLeft + step); }
        else if (event.key === 'ArrowLeft') { event.preventDefault(); move(scroller.scrollLeft - step); }
        else if (event.key === 'Home') { event.preventDefault(); move(0); }
        else if (event.key === 'End') { event.preventDefault(); move(scroller.scrollWidth); }
      });
    }
  }

  function initScrollStories(scope = document) {
    const stories = [];
    if (scope.matches?.(storySelector)) stories.push(scope);
    stories.push(...(scope.querySelectorAll?.(storySelector) || []));

    for (const story of stories) {
      if (story.dataset.castleStoryReady) continue;
      const scroller = story.querySelector('[data-castle-scroll-story-rail]');
      const sticky = story.querySelector('.castle-department-scroll-story__sticky');
      const cue = story.querySelector('[data-castle-scroll-story-cue]');
      const cueContainer = story.querySelector('.castle-department-scroll-story__cue');
      const progressBar = story.querySelector('[data-castle-scroll-story-progress]');
      if (!scroller || !sticky) continue;
      story.dataset.castleStoryReady = 'true';
      let travel = 0;

      function updateProgress() {
        if (travel <= 0) return;
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const top = parseFloat(window.getComputedStyle(sticky).top) || 0;
        const rect = story.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (top - rect.top) / travel));
        scroller.scrollLeft = progress * max;
        if (progressBar) progressBar.style.transform = `scaleX(${progress})`;
      }

      function updateMetrics() {
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        if (reducedMotion.matches || max <= 2) {
          travel = 0;
          story.style.height = '';
          if (cue) cue.textContent = max > 2 ? 'Swipe to explore categories' : '';
          if (cueContainer) cueContainer.style.display = max > 2 ? 'flex' : 'none';
          story.classList.toggle('castle-department-scroll-story--pinned', false);
          return;
        }
        travel = Math.max(window.innerHeight * 1.35, Math.min(max, window.innerHeight * 2.1));
        story.style.height = `${Math.ceil(sticky.offsetHeight + travel)}px`;
        story.classList.add('castle-department-scroll-story--pinned');
        if (cue) cue.textContent = 'Keep scrolling to explore';
        if (cueContainer) cueContainer.style.display = 'flex';
        updateProgress();
      }

      const scrollWrapper = document.querySelector('.page-wrapper');
      scrollWrapper?.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateMetrics, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(updateMetrics).observe(scroller);
      reducedMotion.addEventListener?.('change', updateMetrics);
      requestAnimationFrame(updateMetrics);
    }
  }

  function init(scope = document) {
    initRails(scope);
    initScrollStories(scope);
  }

  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();